<template>
  <div
    class="base-card"
    :class="classes"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';

export default defineComponent({
  name: 'BaseCard',
  extends: BaseComponent,
});
</script>

<style lang="scss" scoped>
.base-card {
  box-sizing: border-box;
}
@if mixin-exists("ThemeBaseCard") {
  @include ThemeBaseCard;
}
</style>
